import React from 'react'; // eslint-disable-line no-unused-vars
import { withRouter } from 'react-router';
import {
    Alert
} from 'react-bootstrap';
import Utils from '../../utils/Utils';

export default function Header(props) { // eslint-disable-line no-unused-vars
        const logo = _determineHeaderLogo();
        return (
            <div style={styles.container} >
                <div className={'header-banner'} >
                    <img style={styles.imageStyle} src={logo}/>
                </div>
            {_renderError(props.error)}
            </div>
        );
    }

function _renderError(error) {
    if (error) {
        return (
            <div>
                <br/>
                <Alert bsStyle="danger" style={styles.errorStyle}>
                    <p>{error.message}</p>
                </Alert>
            </div>
        );
    }
    return null;
}

function _determineHeaderLogo() {
    return Utils.determineHeaderLogo();
}

const styles = {
    container: {
        width: '100%',
    },
    imageStyle: {
        width: '100px',
    },
    error: {
        backgroundColor: 'white',
        width: '100%',
        margin: '10px'
    }
};



// WEBPACK FOOTER //
// ./src/app/components/common/Header.js